module.exports = "../study/imgs/maps/Tokyo/S8/Hazard/Slopefailure/Tokyo_Slopefailure_MIROC5_RCP26_Mid.png";